import fr from './translate-fr';
import en from './translate-en';
const messages = {
    "fr": fr,
    "en": en
}

export const translate = (language: string = "fr", code: string) => {
    if (language === 'undefined') {
        language = 'fr'
    }

    let translatedText = code;
    if (messages[language] && messages[language][code]) {
        translatedText = messages[language][code];
    }
    return translatedText;
}


// WEBPACK FOOTER //
// ./src/utils/translate.ts